import {
    CLEAR_P24_RESTAURANT_MERCHANT,
    FETCH_P24_RESTAURANT_MERCHANT,
    ADD_P24_RESTAURANT_MERCHANT,
    ATTACH_P24_RESTAURANT_MERCHANT,
    DETACH_P24_RESTAURANT_MERCHANT
} from "./actionTypes";

import axios from "axios";
import {
    infoAddToast,
    infoDeleteToast
} from "../components/Toast";
import {
    P24_RESTAURANT_MERCHANT_URL,
    P24_RESTAURANT_MERCHANT_BY_ID_URL
} from "../../config"

/**
 * Pobieranie merchanta p24 z serwera na podstawie podanej restauracji
 * 
 * @param {number} restaurantId identyfikator restauracji
 */
export const fetchP24RestaurantMerchant = (restaurantId) => {
    return dispatch => {
        return axios
            .get(P24_RESTAURANT_MERCHANT_URL(restaurantId))
            .then(response => {
                dispatch(fetchP24RestaurantMerchantSuccess(response.data));
            })
    }
}

/**
 * Czyszzczenie pobranego merchanta p24 z serwera
 */
export const clearP24RestaurantMerchant = () => {
    return dispatch => {
        //przed zapytaniem czyscimy poprzedni wynik
        return dispatch(clearP24RestaurantMerchantSuccess());
    }
}

/**
 * Tworzenie merchanta na serwerze i przypisanie go do restauracji
 * 
 * @param {Integer} restaurantId identyfikator restauracji
 * @param {object} merchant obiekt merchanta do stworzenia
 */
export const createMerchant = (restaurantId, merchant) => {
    return dispatch => {
        return axios
            .post(P24_RESTAURANT_MERCHANT_URL(restaurantId), JSON.stringify(merchant), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(createMerchantSuccess(response.data));
                infoAddToast();
            });
    };
};

/**
 * Przyłączenie merchanta do podanej restauracji
 * 
 * @param {Integer} restaurantId identyfikator restauracji
 * @param {object} merchant obiekt merchanta do stworzenia
 */
export const attachMerchant = (restaurantId, merchant) => {
    return dispatch => {
        return axios
            .post(P24_RESTAURANT_MERCHANT_BY_ID_URL(restaurantId, merchant.id), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(attachMerchantSuccess(merchant));
                infoAddToast();
            });
    };
};

/**
 * Odłączenie merchanta od podanej restauracji
 * 
 * @param {Integer} restaurantId identyfikator restauracji
 * @param {object} merchant obiekt merchanta do stworzenia
 */
export const detachMerchant = (restaurantId, merchant) => {
    return dispatch => {
        return axios
            .delete(P24_RESTAURANT_MERCHANT_BY_ID_URL(restaurantId, merchant.id), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                dispatch(detachMerchantSuccess(response.data));
                infoDeleteToast();
            });
    };
};

/**
 * Akcja pomyślnego czyszczenia merchanta 
 * 
 * @param {object} data Obiekt pobranego merchanta
 */
const clearP24RestaurantMerchantSuccess = () => {
    return {
        type: CLEAR_P24_RESTAURANT_MERCHANT
    };
};

/**
 * Akcja pomyślnego pobrania merchanta 
 * 
 * @param {object} data Obiekt pobranego merchanta
 */
const fetchP24RestaurantMerchantSuccess = data => {
    return {
        type: FETCH_P24_RESTAURANT_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnego utworzenia merchanta
 * 
 * @param {object} data object utworzonego merchanta
 */
const createMerchantSuccess = data => {
    return {
        type: ADD_P24_RESTAURANT_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnego utworzenia merchanta
 * 
 * @param {object} data object utworzonego merchanta
 */
const attachMerchantSuccess = data => {
    return {
        type: ATTACH_P24_RESTAURANT_MERCHANT,
        payload: data
    };
};

/**
 * Akcja pomyślnego utworzenia merchanta
 * 
 * @param {object} data object utworzonego merchanta
 */
const detachMerchantSuccess = data => {
    return {
        type: DETACH_P24_RESTAURANT_MERCHANT
    };
};